import { useEffect } from 'react';
import { useSelector } from 'react-redux';

const ThemeSync = () => {
  const mode = useSelector((state) => state.theme?.mode ?? 'light');

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', mode);
  }, [mode]);

  return null;
};

export default ThemeSync;
